import type { SxProps, Theme } from '@mui/material/styles';
import SvgIcon from '@mui/material/SvgIcon';

type Props = {
	sx?: SxProps<Theme>;
};

export const InactiveRecordsIcon = ({ sx }: Props) => {
	return (
		<SvgIcon width='98' height='110' viewBox='0 0 98 110' fill='none' sx={sx}>
			<defs>
				<clipPath id='inactiveRecordsClip0'>
					<rect width='98' height='110' fill='white' />
				</clipPath>
				<clipPath id='inactiveRecordsClip1'>
					<rect
						width='152'
						height='152'
						fill='white'
						transform='translate(-59.8276 35.8662) rotate(-37.5697)'
					/>
				</clipPath>
			</defs>
			<g clipPath='url(#inactiveRecordsClip0)'>
				<g clipPath='url(#inactiveRecordsClip1)'>
					<path
						d='M69.5395 21.437C70.4323 21.1609 71.2044 20.5942 71.7989 19.8731C74.2897 16.8519 83.2765 7.01246 87.6692 16.4626C88.5058 18.3644 89.3032 32.0059 100.493 28.6015C101.315 28.3551 102.09 27.9702 102.782 27.4636C105.496 25.4639 110.304 20.7617 110.784 16.8026C111.365 12.02 109.435 15.5607 109.435 15.5607C109.435 15.5607 102.677 27.8264 95.4597 25.8807C94.6566 25.6642 93.8165 25.0989 93.2395 24.4997C92.239 23.4609 91.5886 21.5715 91.2459 19.7548C90.7821 17.296 88.9672 6.0266 77.8351 10.9004C75.2869 12.0443 71.8045 13.9898 69.0774 18.7906C67.4867 21.5908 68.4557 21.7722 69.5395 21.437Z'
						fill='#90CAF9'
					/>
					<path
						d='M69.3361 16.8656L67.4079 19.962C66.7422 21.0309 67.0691 22.4371 68.138 23.1027L68.5482 23.3581C69.6171 24.0237 71.0232 23.6968 71.6888 22.6279L73.617 19.5314C74.2826 18.4625 73.9557 17.0564 72.8868 16.3908L72.4767 16.1354C71.4078 15.4698 70.0017 15.7967 69.3361 16.8656Z'
						fill='#1565C0'
					/>
					<path
						d='M54.9706 32.584L48.6114 42.796C48.2786 43.3304 48.442 44.0335 48.9765 44.3663L49.084 44.4332C49.6184 44.766 50.3215 44.6026 50.6543 44.0681L57.0135 33.8561C57.3463 33.3216 57.1829 32.6186 56.6484 32.2858L56.5409 32.2189C56.0065 31.886 55.3034 32.0495 54.9706 32.584Z'
						fill='#1565C0'
					/>
					<path
						d='M62.5859 37.3261L56.2266 47.5381C55.8938 48.0726 56.0573 48.7757 56.5917 49.1085L56.6992 49.1754C57.2337 49.5082 57.9367 49.3448 58.2695 48.8103L64.6288 38.5982C64.9616 38.0638 64.7981 37.3607 64.2637 37.0279L64.1562 36.961C63.6217 36.6282 62.9187 36.7916 62.5859 37.3261Z'
						fill='#1565C0'
					/>
					<path
						d='M62.212 19.7792L57.058 28.0558C56.3924 29.1247 56.7193 30.5308 57.7882 31.1964L65.3385 35.8981C66.4074 36.5637 67.8135 36.2368 68.4791 35.1679L73.6331 26.8913C74.2988 25.8224 73.9718 24.4163 72.9029 23.7506L65.3527 19.049C64.2838 18.3833 62.8777 18.7103 62.212 19.7792Z'
						fill='#1E88E5'
					/>
					<path
						d='M57.0543 26.5048L51.9003 34.7814C51.2347 35.8503 51.5616 37.2564 52.6305 37.922L61.6383 43.5313C62.7072 44.1969 64.1133 43.87 64.7789 42.8011L69.9329 34.5245C70.5985 33.4556 70.2716 32.0495 69.2027 31.3839L60.1949 25.7746C59.126 25.1089 57.7199 25.4359 57.0543 26.5048Z'
						fill='#42A5F5'
					/>
					<path
						d='M56.9577 24.0345L56.9172 24.0994C56.4735 24.812 56.6914 25.7494 57.404 26.1931L70.023 34.0511C70.7356 34.4949 71.673 34.277 72.1167 33.5644L72.1571 33.4995C72.6009 32.7869 72.3829 31.8494 71.6703 31.4057L59.0514 23.5477C58.3388 23.1039 57.4014 23.3219 56.9577 24.0345Z'
						fill='#1565C0'
					/>
					<path
						d='M-11.4171 87.863C-11.4171 87.863 -0.0235542 72.5959 5.10595 83.6309C5.88501 85.402 6.50785 97.128 15.624 95.9754C17.5814 95.7279 19.4079 94.8802 20.9654 93.6691C23.7578 91.4977 27.7874 87.539 28.2207 83.9706C28.8012 79.1879 26.8714 82.7286 26.8714 82.7286C26.8714 82.7286 21.1648 92.5847 14.7642 93.1512C12.5787 93.3447 10.5218 92.0463 9.61781 90.0471C9.1745 89.0496 8.86021 87.9997 8.68254 86.9227C8.27081 84.4547 6.40376 73.1945 -4.72839 78.0684C-7.27657 79.2122 -10.759 81.1578 -13.4859 85.9585C-16.2129 90.7593 -11.4171 87.863 -11.4171 87.863Z'
						fill='#90CAF9'
					/>
					<path
						d='M27.4535 78.9281L25.5253 82.0245C24.8597 83.0934 25.1866 84.4996 26.2555 85.1652L26.6656 85.4206C27.7345 86.0862 29.1406 85.7593 29.8062 84.6904L31.7345 81.5939C32.4001 80.525 32.0732 79.1189 31.0043 78.4533L30.5942 78.1979C29.5252 77.5322 28.1191 77.8592 27.4535 78.9281Z'
						fill='#1565C0'
					/>
					<path
						d='M28.6013 70.954L25.7435 75.5431C25.0779 76.612 25.4048 78.0181 26.4737 78.6837L32.3863 82.3656C33.4552 83.0312 34.8613 82.7043 35.527 81.6354L38.3847 77.0463C39.0503 75.9774 38.7234 74.5713 37.6545 73.9057L31.7419 70.2238C30.673 69.5581 29.2669 69.8851 28.6013 70.954Z'
						fill='#1E88E5'
					/>
					<path
						d='M32.2201 61.8342L27.9584 68.6779C27.2928 69.7468 27.6197 71.1529 28.6886 71.8185L37.6964 77.4278C38.7653 78.0934 40.1714 77.7665 40.837 76.6976L45.0987 69.8539C45.7643 68.785 45.4374 67.3789 44.3685 66.7133L35.3607 61.104C34.2918 60.4383 32.8857 60.7653 32.2201 61.8342Z'
						fill='#42A5F5'
					/>
					<path
						d='M32.2328 59.2269L32.1924 59.2918C31.7486 60.0044 31.9666 60.9418 32.6792 61.3855L45.2981 69.2435C46.0107 69.6873 46.9481 69.4693 47.3919 68.7567L47.4323 68.6918C47.876 67.9792 47.6581 67.0418 46.9455 66.5981L34.3266 58.7401C33.614 58.2963 32.6766 58.5142 32.2328 59.2269Z'
						fill='#1565C0'
					/>
					<path
						d='M42.107 40.441C41.873 40.5829 41.5932 40.6285 41.3263 40.5682C41.0595 40.5079 40.8264 40.3464 40.6762 40.1177L34.8484 31.6179C34.5003 31.1102 34.6269 30.4236 35.127 30.1075L35.8239 29.6672C36.3239 29.3511 36.9958 29.5328 37.3026 30.0668L42.4333 39.007C42.574 39.2421 42.6186 39.5224 42.5578 39.7895C42.497 40.0566 42.3355 40.29 42.107 40.441Z'
						fill='#90CAF9'
					/>
					<path
						d='M38.7922 44.1103C38.7403 44.1815 38.6749 44.2419 38.5997 44.2878C38.5244 44.3338 38.4409 44.3645 38.3538 44.3782C38.2668 44.3919 38.1778 44.3883 38.0921 44.3677C38.0064 44.347 37.9257 44.3096 37.8544 44.2577L32.3568 40.4108C32.1994 40.3022 32.0916 40.1356 32.0569 39.9475C32.0222 39.7595 32.0636 39.5654 32.1718 39.4077L32.4889 38.9656C32.5438 38.8904 32.6137 38.8274 32.6942 38.7806C32.7747 38.7339 32.864 38.7043 32.9566 38.6938C33.0491 38.6832 33.1427 38.692 33.2317 38.7195C33.3206 38.747 33.4029 38.7927 33.4733 38.8536L38.654 43.1427C38.7945 43.2571 38.8866 43.4202 38.9122 43.5995C38.9378 43.7788 38.895 43.9611 38.7922 44.1103Z'
						fill='#90CAF9'
					/>
					<path
						d='M38.8912 48.6916C38.8778 49.2654 38.2999 49.7032 37.5812 49.6841L24.8195 49.3448C24.0573 49.3245 23.4335 48.8001 23.448 48.1916L23.4678 47.3433C23.4821 46.7347 24.1283 46.2865 24.8895 46.3575L37.6313 47.5452C38.3488 47.612 38.9046 48.1178 38.8912 48.6916Z'
						fill='#90CAF9'
					/>
					<path
						d='M55.1989 62.3798C55.4613 62.3024 55.7435 62.3298 55.9861 62.4562C56.2288 62.5827 56.4129 62.7983 56.4997 63.0578L59.9633 72.7638C60.1702 73.3436 59.8722 73.9749 59.3081 74.1531L58.5217 74.401C57.9576 74.5789 57.354 74.2317 57.1941 73.6371L54.5169 63.6831C54.4407 63.4198 54.4692 63.1373 54.5962 62.8945C54.7233 62.6517 54.9392 62.4673 55.1989 62.3798Z'
						fill='#90CAF9'
					/>
					<path
						d='M59.3407 59.6788C59.409 59.6232 59.4877 59.5815 59.5721 59.5563C59.6566 59.531 59.7452 59.5226 59.8329 59.5316C59.9206 59.5406 60.0057 59.5668 60.0832 59.6087C60.1608 59.6505 60.2294 59.7073 60.285 59.7756L64.6178 64.8991C64.7423 65.0443 64.804 65.2329 64.7895 65.4236C64.775 65.6143 64.6855 65.7914 64.5406 65.9162L64.121 66.2628C64.0487 66.3214 63.965 66.3644 63.8753 66.3891C63.7855 66.4138 63.6916 66.4196 63.5994 66.4061C63.5073 66.3926 63.419 66.3602 63.34 66.3109C63.261 66.2616 63.1931 66.1965 63.1406 66.1196L59.2273 60.6495C59.1208 60.5031 59.0733 60.3219 59.0943 60.142C59.1153 59.9621 59.2033 59.7968 59.3407 59.6788Z'
						fill='#90CAF9'
					/>
					<path
						d='M60.415 55.2236C60.5746 54.6722 61.245 54.3965 61.9351 54.5986L74.1867 58.1856C74.9186 58.3999 75.3875 59.0659 75.2181 59.651L74.9821 60.4661C74.813 61.0509 74.0737 61.3191 73.3559 61.0561L61.3397 56.6539C60.6637 56.4058 60.2555 55.775 60.415 55.2236Z'
						fill='#90CAF9'
					/>
				</g>
			</g>
		</SvgIcon>
	);
};
